export default __webpack_public_path__ + "static/media/weight-icon.c8d6eda0.svg";